<template>
  <div
    v-click-outside="close"
    class="retailer-search-type-fi"
  >
    <div
      class="retailer-search-type-fi__button"
      :class="{
        'retailer-search-type-fi__button': true,
        'retailer-search-type-fi__button--open': openSelect,
      }"
      @click="toggleSelect"
    >
      <div class="retailer-search-type-fi__button__label">
        <icon-fi :icon="activeRetailersCount ? 'checkbox-checked' : 'filter'" />

        {{ facet.name }}

        <span
          v-if="activeRetailersCount"
          class="active-count"
          >({{ activeRetailersCount }})</span
        >
      </div>

      <icon-fi
        class="retailer-search-type-fi__button__icon"
        icon="chevron-down"
      />

      <div class="retailer-search-type-fi__button__label--mobile">
        <icon-fi :icon="activeRetailersCount ? 'checkbox-checked' : 'filter'" />
      </div>
    </div>

    <transition
      mode="in-out"
      appear
      leave-active-class="retailer-search-type-fi__options--leaving"
      @after-leave="close"
    >
      <div
        v-if="openSelect"
        class="retailer-search-type-fi__options"
      >
        <div class="retailer-search-type-fi__options__header">
          {{ facet.name }}

          <icon-fi
            class="retailer-search-type-fi__options__header__icon"
            icon="close"
            @click="close"
          />
        </div>

        <div class="retailer-search-type-fi__options__body">
          <retailer-search-type-options-fi
            :elements="retailerTypeOptions"
            :emit-only-on-save="!isSM"
            :partners="activePartners"
            :retailers="activeRetailers"
            @select-changed="selectChanged"
          />
        </div>

        <div class="retailer-search-type-fi__options__bottom">
          <button-fi
            class="button-fi__primary button-fi--large button-fi__xs-streched retailer-search-type-fi__options__save"
            @click="save"
          >
            {{ $dict.get('dealer-Locator.Facets.Labels.Use-Facet') }}
          </button-fi>
          <div
            class="retailer-search-type-fi__options__clear"
            @click="clear"
          >
            {{ $dict.get('dealer-Locator.Facets.Labels.Clear-Facet') }}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { ButtonFi, IconFi } from 'atoms';
import bodyScrollMixin from 'mixins/bodyScrollMixin';
import breakpointMixin from 'mixins/breakpointMixin';

import RetailerSearchTypeOptionsFi from './retailer-search-type-options-fi/RetailerSearchTypeOptionsFi';

export default {
  name: 'RetailerSearchTypeFi',
  components: {
    ButtonFi,
    IconFi,
    RetailerSearchTypeOptionsFi,
  },
  mixins: [bodyScrollMixin, breakpointMixin],
  props: {
    facet: {
      type: Object,
      required: true,
    },
    retailersCount: {
      type: String,
      default: null,
    },
  },
  emits: ['retailer-type-changed'],
  data() {
    return {
      openSelect: false,
      active: false,
      retailerTypeOptions: null,
      changedOptions: null,
      activePartners: [],
      activeRetailers: [],
    };
  },
  computed: {
    activeRetailersCount() {
      if (this.active) {
        return this.retailersCount;
      }

      return null;
    },
  },
  created() {
    this.retailerTypeOptions = JSON.parse(JSON.stringify(this.facet.elements));
  },
  methods: {
    toggleSelect() {
      if (this.openSelect) {
        this.close();
      } else {
        this.open();
      }
    },
    open() {
      this.openSelect = true;

      if (!this.isSM) {
        this.bodyDisableScroll();
      }
    },
    close() {
      this.openSelect = false;

      if (!this.isSM) {
        this.bodyEnableScroll();
      }
    },
    selectChanged(val) {
      const { newElements, activePartners, activeRetailers } = val;
      this.changedOptions = newElements;
      this.activePartners = activePartners;
      this.activeRetailers = activeRetailers;

      if (this.isSM) {
        this.active = Boolean(activePartners.length || activeRetailers.length);
        this.retailerTypeOptions = newElements;
        this.$emit('retailer-type-changed', {
          partners: activePartners,
          retailers: activeRetailers,
        });
      }
    },
    save() {
      this.retailerTypeOptions = this.changedOptions;
      this.active = Boolean(this.activePartners.length || this.activeRetailers.length);
      this.$emit('retailer-type-changed', {
        partners: this.activePartners,
        retailers: this.activeRetailers,
      });
      this.close();
    },
    clear() {
      this.active = false;
      this.retailerTypeOptions = JSON.parse(JSON.stringify(this.facet.elements));
      this.activePartners = [];
      this.activeRetailers = [];
      this.$emit('retailer-type-changed', { partners: [], retailers: [] });
      this.close();
    },
  },
};
</script>

<style scoped lang="scss">
@import './retailer-search-type-fi';
</style>
